import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  TablePagination,
  IconButton,
  CircularProgress,
  Backdrop,
} from "@material-ui/core";

import Card from "../../../../StyledComponents/Card/Card";
import CardHeader from "../../../../StyledComponents/Card/CardHeader";
import CardText from "../../../../StyledComponents/Card/CardText";
import CardBody from "../../../../StyledComponents/Card/CardBody";
import { makeStyles } from "@material-ui/styles";
import moment from "moment";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { formatDateTimeForBackend } from "../../../../Functions";
import { dashboardStyle } from "../../../Invoices/Components/InvoiceDetails/style";
import CustomSnackbar from "../../../../CustomSnackbar";
import Signatories_Table from "./Signatories_Table";
import getParameterByName from "../../../../Functions/functions";

const useStyles = makeStyles(dashboardStyle);

const Signatories = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [invoices, setInvoices] = useState([]);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [emailloader, setEmailLoader] = useState(false);
  const [count, setCount] = useState(0);
  const [archieve, setIsArchieve] = useState("false");
  const [batchNo, setBatchNo] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [validation, setValidation] = useState("");
  const Date = getParameterByName("Date");


  const [formState, setFormState] = useState({
   clearingDateFrom: Date? Date : moment().subtract(3, "d").format("YYYY-MM-DD"),
    clearingDateTo: Date? Date : moment().format("YYYY-MM-DD"),
    batchFromDate: Date? Date : moment().subtract(3, "d").format("YYYY-MM-DD"),
    batchToDate: Date? Date : moment().format("YYYY-MM-DD"),
    vendor_Code: "",
    signatory: [],
    RowsOfPage: 10,
    PageNo: 1,
  });
  
  const getBtachesData = async () => {
    setInvoiceLoading(true);
    const axios = require("axios");
    let config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/api/Signatory/GetBatch?isArchive=${archieve == "true" ? true : false
        }&fromDate=${formState?.clearingDateFrom}&toDate=${formState?.clearingDateTo
        }`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        "Content-Type": "application/json",
      },
    };
    axios
      .request(config)
      .then((response) => {
        setCount(response.data.length);
        setInvoices(response.data);
        setInvoiceLoading(false);
      })
      .catch((error) => {

      });
  };

  useEffect(() => {
    getBtachesData();
  }, [formState?.clearingDateFrom, formState?.clearingDateTo, archieve , formState?.RowsOfPage , formState?.PageNo,]);

  console.log(formState.PageNo, "formState.PageNo")
  const autocompleteChangeHandler = (name, value) => {
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
  };

  const handleChangePage = (event, newPage) => {
    setFormState((formState) => ({
      ...formState,
      PageNo: newPage + 1,
    }));
  };

  const handleChangeRowsPerPage = (event) => {

    setFormState((formState) => ({
      ...formState,
      RowsOfPage: event.target.value,
    }));
  };
  return (
    <Card style={{ marginLeft: "20px" }}>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={emailloader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <CardHeader color="primary" text>
        <CardText
          style={{
            padding: "1px 20px",
            backgroundColor: "#031C30",
            color: "white",
            height: "62px",
          }}
        >
          <Grid container justifyContent="space-between">
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <h4>Signatories</h4>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <IconButton
                variant="contained"
                style={{ float: "right", marginTop: "1.5%" }}
                onClick={() => navigate("/home")}
              >
                <ArrowBack style={{ color: "#fff" }} titleAccess="Go Back" />
              </IconButton>
            </Grid>
          </Grid>
        </CardText>
      </CardHeader>
      <CardBody>
        <form>
          <Grid container spacing={2} mt={1}>
            <Grid
              item
              xs={6}
              sm={6}
              md={4}
              lg={3}
              style={{ paddingRight: "18px" }}
            >
              <Typography>Date From:</Typography>
              <input
                className={classes.inputField}
                type="date"
                max="9999-12-31"
                value={formState.clearingDateFrom}
                onChange={(newValue) => {
                  autocompleteChangeHandler(
                    "clearingDateFrom",
                    newValue.target.value,
                    formatDateTimeForBackend(newValue)
                  );
                }}
                style={{ height: 13 }}
              />
          
            </Grid>

            <Grid
              item
              xs={6}
              sm={6}
              md={4}
              lg={3}
              style={{ paddingRight: "18px" }}
            >
              <Typography>Date To:</Typography>
              <input
                className={classes.inputField}
                type="date"
                max="9999-12-31"
                value={formState.clearingDateTo}
                onChange={(newValue) => {
                  autocompleteChangeHandler(
                    "clearingDateTo",
                    newValue.target.value,
                    formatDateTimeForBackend(newValue)
                  );
                }}
                style={{ height: 13 }}
              />
             
            </Grid>
          </Grid>
        
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Signatories_Table
              vendorList={invoices}
              loading={invoiceLoading}
              page={formState.PageNo}
              RowsPerPage={formState.RowsOfPage}
              batchNo={batchNo}
              setBatchNo={setBatchNo}
              errorMessage={validation}
            />

            <TablePagination
              rowsPerPageOptions={[10 , 25, 50, 100]}
              component="div"
              count={count}
              rowsPerPage={formState.RowsOfPage}
              page={parseInt(formState.PageNo) - 1}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
            {successMessage && (
              <CustomSnackbar
                open={successMessage !== ""}
                message={successMessage}
                handleClose={() => setSuccessMessage("")}
                variant="success"
              />
            )}
            {errorMessage && (
              <CustomSnackbar
                open={errorMessage !== ""}
                message={errorMessage}
                handleClose={() => setErrorMessage("")}
                variant="error"
              />
            )}
          </Grid>
         
        </form>
      </CardBody>
    </Card>
  );
};

export default Signatories;
